import React, { useState } from 'react';
import styled from 'styled-components';
import AdminUser from './Components/AdminDashBoard/AdminUser';
import Merchantprofile from './Components/AdminDashBoard/Merchantprofile';
import HeroImagesForm from './Components/AdminDashBoard/HeroImagesForm';
import BannerImagesForm from './Components/AdminDashBoard/BannerImagesForm';
import TopCouponsImagesForm from './Components/AdminDashBoard/TopCouponsImagesForm';
import CardImagesForm from './Components/AdminDashBoard/CardImagesForm';
import SeasonalOffersForm from './Components/AdminDashBoard/SeasonalOffersForm';
import FlashText from './Components/AdminDashBoard/FlashText';
import TopBannerIMagesForm from './Components/AdminDashBoard/TopBannerIMagesForm';
import Payment from './Components/AdminDashBoard/Payment';
import TopMiddle from "./Components/AdminDashBoard/TopMiddle"
import PickProductsApprovel from './Components/AdminDashBoard/PickProductsApprovel';
import PremiumCouponApproval from './Components/AdminDashBoard/PremiumCouponApproval';
import MailContaacts from './Components/AdminDashBoard/MailContaacts';

const AdminDashBoard = () => {
  const [activeForm, setActiveForm] = useState('hero');
  const [adminName, setAdminName] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (adminName === 'BakpoketAdmin' && password === 'Admin1@#') {
      setIsLoggedIn(true);
    } else {
      alert('Invalid admin credentials');
    }
  };

  return (
    <OuterWrapper>
      <InnerWrapper>
        <DashboardHeader>
          <LeftSection>
            <img src="/images/icon.png" alt="Logo" />
            <h1>Admin Dashboard</h1>
          </LeftSection>
        </DashboardHeader>

        {!isLoggedIn && (
          <AdminLoginPage>
            <form onSubmit={handleLogin}>
              <h3>Admin Login</h3>
              <input
                placeholder="Bakpoket Admin Name"
                value={adminName}
                onChange={(e) => setAdminName(e.target.value)}
                className='form-control'
              />
              <input
                type="password"
                placeholder="Admin Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className='form-control'
              />
              <button type="submit">Login</button>
            </form>
          </AdminLoginPage>
        )}

        {isLoggedIn && (
          <MainContainer>
            <Sidebar>
              <div className="top">
            
                <p className={activeForm === 'hero' ? 'active' : ''} onClick={() => setActiveForm('hero')}>Hero Images</p>
                <p className={activeForm === 'User' ? 'active' : ''} onClick={() => setActiveForm('User')}>Admin USer </p>
                <p className={activeForm === 'Merchantprofile' ? 'active' : ''} onClick={() => setActiveForm('Merchantprofile')}>Merchant USer </p>
                <p className={activeForm === 'topmiddle' ? 'active' : ''} onClick={() => setActiveForm('topmiddle')}>Top Middle Images</p>
                <p className={activeForm === 'topbanner' ? 'active' : ''} onClick={() => setActiveForm('topbanner')}>Top Banner Images</p>
                <p className={activeForm === 'banner' ? 'active' : ''} onClick={() => setActiveForm('banner')}>Cat_TC_BO Images</p>
                <p className={activeForm === 'top' ? 'active' : ''} onClick={() => setActiveForm('top')}>Top Coupons Images</p>
                <p className={activeForm === 'card' ? 'active' : ''} onClick={() => setActiveForm('card')}>Card Images</p>
                <p className={activeForm === 'seasonal' ? 'active' : ''} onClick={() => setActiveForm('seasonal')}>Seasonal Offers</p>
                <p className={activeForm === 'flash' ? 'active' : ''} onClick={() => setActiveForm('flash')}>Flash Text</p>
                <p className={activeForm === 'approval' ? 'active' : ''} onClick={() => setActiveForm('approval')}>Products Approval</p>
                <p className={activeForm === 'PremiumCouponApproval' ? 'active' : ''} onClick={() => setActiveForm('PremiumCouponApproval')}>Premium Coupon</p>
                <p className={activeForm === 'MailContaacts' ? 'active' : ''} onClick={() => setActiveForm('MailContaacts')}>Contact Form Details</p>
                
                {/* <p className={activeForm === 'payment' ? 'active' : ''} onClick={() => setActiveForm('payment')}>Payment</p> */}
              </div>
            </Sidebar>

            <MainContent>
                        
              {activeForm === 'hero' && <HeroImagesForm />}
              {activeForm === 'User' && <AdminUser />}
              {activeForm === 'Merchantprofile' && <Merchantprofile />}
              {activeForm === 'topmiddle' && <TopMiddle />}
              {activeForm === 'topbanner' && <TopBannerIMagesForm />}
              {activeForm === 'banner' && <BannerImagesForm />}
              {activeForm === 'top' && <TopCouponsImagesForm />}
              {activeForm === 'card' && <CardImagesForm />}
              {activeForm === 'seasonal' && <SeasonalOffersForm />}
              {activeForm === 'flash' && <FlashText />}
              {activeForm === 'approval' && <PickProductsApprovel />}
              {activeForm === 'PremiumCouponApproval' && <PremiumCouponApproval />}
              {activeForm === 'MailContaacts' && <MailContaacts />}
              {/* {activeForm === 'payment' && <Payment />} */}
            </MainContent>
          </MainContainer>
        )}
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default AdminDashBoard;


const OuterWrapper = styled.section`
  background-color: #fffff;
  padding: 30px 15px;
  display: flex;
  justify-content: center;

  .hidden{
    display: none;
  }

  @media(max-width:576px){
    padding: 30px 5px;
  }
`;

const InnerWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  border-radius: 30px;
  overflow: hidden;
  background-color: rgba(228, 232, 235, 0.88);
  font-family: Arial, sans-serif;
`;

const DashboardHeader = styled.div`
  background: linear-gradient(to right, #2a4157, #ef4766);
  padding: 15px 30px;
  color: white;
  display: flex;
  align-items: center;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  img {
    width: 40px;
  }

  h1 {
    font-size: 22px;
    margin: 0;
  }

  @media (max-width: 768px) {
    img {
      width: 24px;
    }

    h1 {
      font-size: 16px;
    }
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    flex-direction: row;
    overflow-x: auto;
  }
`;

const Sidebar = styled.div`
  background-color: #ef4766;
  width: 240px;
  padding: 30px;
  flex-shrink: 0;

  .top {
    display: flex;
    flex-direction: column;
    gap: 12px;

    p {
      color: white;
      margin: 0;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.2s ease, opacity 0.2s ease;
      padding: 6px 10px;
      border-radius: 6px;

      &:hover {
        opacity: 0.8;
      }

      &.active {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  @media (max-width: 768px) {
    width: 100px;
    padding: 20px 10px;

    .top {
      gap: 12px;

      p {
        font-size: 10px;
        padding: 4px 3px;

        &:hover {
          opacity: 0.8;
        }

        &.active {
          background-color: rgba(255, 255, 255, 0.2);
        }
      }
    }
  }
`;

const MainContent = styled.div`
  flex: 1;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 20px 10px;
  }
`;

const AdminLoginPage = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: 20px auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;

    input[type="file"] {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 85%;
    padding: 5px;
    gap:2px;

    h2 {
      font-size: 13px;
    }

    button {
      font-size: 10px;
      padding: 8px 12px;
    }

    input {
      padding: 6px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size:9px;
    }
  }
`;
